<template>
	<section class="gubernamental">
		<p class="titleColorSystem">gubernamental</p>
	    <div class="sci-gub-texto">Aquí pueden apreciarse un listado de las instituciones gubernamentales registradas,
				a las cuales se les puede hacer una búsqueda mediante el nombre de la institución, nombre del titular o
				estado al que pertenece.</div>
		<div class="sci-gub-content">
	    	<table class="sci-gub-table">
	    		<thead class="sci-gub-thead">
	    			<div class="sci-gub-busqueda">
	    				<input v-model="search" type="text" placeholder="Buscar Institución" autofocus @keyup.enter="listarGubernamentales"  @click="limpiarCampos"><button @click="listarGubernamentales" class="sci-gub-lupa"></button>
	    			</div>
						<span class="sci-gub-count">Hay {{ gubCount }} instituciones gubernamentales que coinciden con el filtro
							<br><vue-excel-xlsx
								v-if="this.nuevasGubernamentales.data.length > 0"
								class="sci-gub-excel"
								:data="gubernamentalesExcel.data"
								:columns="columns"
								:filename="'Instituciones academicas'"
								:sheetname="'academicas1'"
							>
								Descargar datos de instituciones gubernamentales
							</vue-excel-xlsx>
						</span>
	    			<tr class="sci-gub-tr1">
		    			<td>nombre de la institucion</td>
		    			<td>enlace CTI</td>
		    			<td>municipio</td>
		    		</tr>
	   			</thead>
	   			<tbody class="sci-gub-tbody">
	   				<tr class="sci-gub-tr2" v-for="gubernamental in nuevasGubernamentales.data" :key="gubernamental.id">
	   					<td>{{ gubernamental.nombre }}</td>
	   					<td>{{ gubernamental.nombre_titular }} {{ gubernamental.ap_pat_titular }}</td>
	   					<td>{{ gubernamental.municipio }}</td>
	   				</tr>
	   			</tbody>
					<v-spacer></v-spacer>
					<div class="pagination justify-content-center">
						<pagination :limit="vPaginator.limit" :data="nuevasGubernamentales" @pagination-change-page="listarGubernamentales"></pagination>
					</div>
					<v-spacer></v-spacer>
	    	</table>
		</div>
	</section>
</template>

<script>
	import axios from 'axios'
	export default {
		name: 'gubernamental',
		props: ["urlApi"],
		data: function(){
			return{
				columns: [
					{label: "Nombre de la Institución", field: "nombre"},
					{label: "Enlace CTI", field: "nombre_titular"},
					{label: "Municipio", field: "municipio"},
				],
				selected: 4,
				search: null,
				CurrentElement: {},
				nuevasGubernamentales: {
					current_page: 1,
					data: []
				},
				gubernamentalesExcel: {},
				vPaginator: {
					limit: 10
				},
			}
		},
		watch: {
			search: function (value) {
				this.listarGubernamentales();
				this.getGubernamentales();
			},
		},
		methods:{
			listarGubernamentales: function (page = 1) {
				var url= process.env.VUE_APP_API_URL + `/api/gubernamental?page=${page}&query=${this.search}`;
				axios.get(url)
					.then(response => {this.nuevasGubernamentales = response.data;})
					.catch(error => errorHandling(error));
			},
			getGubernamentales: function (page = 1) {
				var url= process.env.VUE_APP_API_URL + `/api/gubernamental?perPage=200&page=1&query=${this.search}`;
				axios.get(url)
					.then(response => {this.gubernamentalesExcel = response.data;})
					.catch(error => errorHandling(error));
			},
			limpiarCampos(){
				this.search = ''
				this.CurrentElement.nombre = ''
				this.CurrentElement.nombre_titular = ''
				this.CurrentElement.ap_pat_titular = ''
				this.CurrentElement.ap_mat_titular = ''
				this.CurrentElement.cargo_titular = ''
				this.CurrentElement.domicilio = ''
				this.CurrentElement.municipio = ''
				this.CurrentElement.correo_titular = ''
				this.CurrentElement.horario_oficina = ''
				this.CurrentElement.telefono = ''
			},
			getCurrentElement: function (ElementId) {
				 this.CurrentElement = this.gubernamentales.find(item=>{
					return item.id == ElementId;
				})
				console.log(CurrentElement)
			}
		},
		computed:{
			gubCount: function(){
				return this.nuevasGubernamentales.total;
			},
		},
		created(){
			this.listarGubernamentales();
			this.limpiarCampos();
		},
	}
</script>

<style>
	.sci-gub-title{
		margin: 3% auto 0%;
		text-transform: uppercase;
		color: rgba(255,196,0,.9);
		font-weight: bold;
		font-size: 1.5em;
	}
	.sci-gub-dot{
		font-weight: bold;
		color: rgba(0,152,255,.9)
	}
	.sci-gub-dot:before{
		content:'';
		display: inline-block;
		width: 90px;
		height: 1px;
		background: rgba(0,0,0,0.5);
		margin-right: 1.2%;
		border-radius: 1px 1px;
	}
	.sci-gub-dot:after{
		content:'';
		display: inline-block;
		width: 90px;
		height: 1px;
		background: rgba(0,0,0,0.5);
		margin-left: 1.2%;
		border-radius: 0 0 0 0;
	}
	.sci-gub-texto{
		width: 50%;
		margin: 1% auto;
		line-height: 1.5;
	}
	.sci-gub-content{
		display: grid;
		grid-template-areas: "sci-gub-table";
		grid-template-columns: 5fr;
	}
	.sci-gub-table{
		display: grid;
		grid-area: sci-gub-table;

		border-spacing: 0;
		margin-left: auto; 
		margin-right: auto;
		margin-top: 50px;
		width: 80%;
		align-content: start;
		margin-bottom: 200px;
		padding: 15px;border-radius: 10px 10px 10px 10px;
		-moz-border-radius: 10px 10px 10px 10px;
		-webkit-border-radius: 10px 10px 10px 10px;
		border: 1px solid #aaa;
	}
	.sci-gub-thead{
		background: transparent;
		text-align: left;
		color: #FFF;
		padding: 15px;
	}
	.sci-gub-busqueda{
		color: #000;
		display: grid;
		justify-content: start;
		width: 100%;
		grid-template-columns: 1fr;
	}
	.sci-gub-busqueda input{
		width: 40%;
		height: 25px;
		margin: 0 0 13px 0;
		border-radius: 0px 0 0 0px;
		border: none;
		padding: 0 15px;
		font-size: .8em;
		position: relative;
		background: gainsboro;
		padding: 15px;border-radius: 10px 10px 10px 10px;
		-moz-border-radius: 10px 10px 10px 10px;
		-webkit-border-radius: 10px 10px 10px 10px;
		border: 1px solid #aaa;
	}
	.sci-gub-busqueda input:focus{
		outline: 0;
	}
	.sci-gub-busqueda input::placeholder{
		text-transform: uppercase;
	}
	.sci-gub-lupa{
		background: #0084FF;
		border: none;
		width: 35px;
		height: 32px;
		position: relative;
		left: 37%;
		top: -45px;
		padding: 15px;border-radius: 10px 10px 10px 10px;
		-moz-border-radius: 10px 10px 10px 10px;
		-webkit-border-radius: 10px 10px 10px 10px;
	}
	.sci-gub-lupa:before{
		display: inline-block;
		content: '';
		width: 12px;
		height: 12px;
		border-radius: 50%;
		border: 2px solid #FFF;
		position: relative;
		left: -6px;
		top: -12px;
	}
	.sci-gub-lupa:after{
		content: '';
		width: 10px;
		height: 2px;
		display: inline-block;
		background: #FFF;
		transform: rotate(45deg);
		position: absolute;
		top: 18px;
		left: 17px;
	}
	.sci-gub-count{
		color: #0D47A1;
		font-size: 1.03rem;
		font-weight: bold;
		display: grid;
		text-align: left;
		padding: 0rem 1rem 1rem 0;
	}
	.sci-gub-excel{
		font-weight: bold;
		color: rgb(117, 180, 239);
		font-size: 1.1rem;
		border: 1px solid #ccc;
		padding: .4rem;
		margin: 1rem 0 0 0;
		border-radius: 5px;
		width: 50%;
	}
	.sci-gub-tr1{
		display: grid;
		grid-template-columns: 4fr 4fr 2fr;
		text-transform: uppercase;
		font-weight: 100;
		color: #000; 
		background-color: gainsboro;
		border-radius: 5px 5px 5px 5px;
		-moz-border-radius: 10px 10px 10px 10px;																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																														
		-webkit-border-radius: 5px 5px 5px 5px;
	}
	.sci-gub-tbody{
		text-align: left;
	}
	.sci-gub-tr2{
		display: grid;
		grid-template-columns: 4fr 4fr 2fr;
		text-transform: uppercase;
	}
	.sci-gub-tr2 td {
		padding: 10px;
	}
	.sci-gub-nameGub{
		width: 100%;
		text-align: left;
		margin: 2% 4%;
		color: rgba(0,132,255,1);
		font-size: 1.7em;
	}
	.sci-gub-info2{
		display: grid;
	}

	@media only screen and (max-width: 850px) and (min-width: 100px) {
		.sci-gub-content{
			grid-template-areas: "sci-gub-table";
			grid-template-columns: 1fr;
		}
		.sci-gub-table{
			width: 90%;
			margin: 2% auto;
			margin-bottom: 100px;
		}
	}
</style>